
<template>
    <v-container class="ts-username py-0" ref="animated" :class="animate" :style="{ 'color': color }" @mouseover="onMouseOver" @mouseout="onMouseOut" @click="onClick" v-if="parsedUsername">
        <span :class="font && fontActive ? font : ''">{{ parsedUsername.first }} <span :class="font && fontActive ? '' : { 'font-italic': true, 'font-weight-light': true }">({{parsedUsername.nickname}})</span>{{ parsedUsername.last }}</span>
    </v-container>
</template>
<style>
:root {
    --animate-delay: 0.1s;
}
.ts-username {
    cursor: pointer;
}
</style>
<script>
import "animate.css";
import {} from "@mdi/js";
import parseUsername from "../utils/ParseUsername.js";

export default {
    name: "ts-username",
    components: {},
    props: {
        username: String,
        font: String,
        chosen: String,
        index: Number,
        setFirstLoad: Object,
    },
    methods: {
        onMouseOver() {
            this.fontActive = true;
        },
        onMouseOut() {
            this.fontActive = false || this.chosen === this.username;
        },
        onClick() {
            this.$emit("chosen", this.username);
        },
    },
    data: function () {
        return {
            fontActive: true,
            animationEnded: false,
            loaded: false,
            firstLoad: true,
            animateDelays: ['animate__delay-2s', 'animate__delay-3s', 'animate__delay-4s']
        };
    },
    computed: {
        parsedUsername: function () {
            return this.username ? parseUsername(this.username) : undefined;
        },
        animate: function () {
            const animate = !this.loaded
                ? `animate__animated animate__bounceIn ${this.animateDelays[this.index]}`
                : (this.fontActive && !this.firstLoad) ? "animate__animated animate__jello" : '';
            console.log('animate: ', animate, 'fontActive: ', this.fontActive, 'firstLoad: ', this.firstLoad, 'boolean: ', (this.fontActive && !this.firstLoad))
            return animate
        },
        selected: function () {
            return this.username === this.chosen;
        },
        color: function() {
            return this.selected && this.animationEnded ? '#F44336' : '';
        },
    },
    mounted() {
        this.$refs.animated.addEventListener('animationend', () => {
            this.loaded = true;
            this.animationEnded = true;
            if (this.firstLoad) this.fontActive = false;
        });
        setTimeout(() => {
            
            this.firstLoad = this.setFirstLoad.bool;
        }, 3000)
    },
    watch: {
        chosen: function (value, previousValue) {
            if (value !== previousValue && value !== this.username) this.animationEnded = false;
            this.fontActive = value === this.username;
        },
    },
};
</script>
